import React, { useEffect, useState } from 'react';
import { PlayCircleIcon, ShieldCheckIcon, StarIcon } from 'lucide-react';
const BRANDS = ['Birdcall', 'Thai Chili 2 Go', 'Extra Space Storage', 'Bosa Donuts', 'Maricopa Water & Ice', "Nando's", 'KinderCare', 'Sprouts', "Duke's Roadhouse", 'Darwin Wall Real Estate', 'Original ChopShop'];
export function HeroSection() {
  const [wordsVisible, setWordsVisible] = useState(false);
  const [subVisible, setSubVisible] = useState(false);
  const [ctasVisible, setCtasVisible] = useState(false);
  useEffect(() => {
    const t1 = setTimeout(() => setWordsVisible(true), 200);
    const t2 = setTimeout(() => setSubVisible(true), 1000);
    const t3 = setTimeout(() => setCtasVisible(true), 1400);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, []);
  const lines = [{
    text: 'Your Property.',
    color: '#0283C7'
  }, {
    text: 'Our Pressure.',
    color: '#025A8A'
  }, {
    text: 'Spotless Results.',
    color: '#0283C7'
  }];
  return <section id="hero" className="w-full min-h-screen relative overflow-hidden" style={{
    backgroundColor: '#E8F4FD',
    paddingTop: '80px'
  }} aria-label="Hero section" data-id="element-81">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 pointer-events-none" style={{
      opacity: 0.04
    }} data-id="element-82">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-83">
          <defs data-id="element-84">
            <pattern id="dots" x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-85">
              <circle cx="20" cy="20" r="2" fill="#0283C7" data-id="element-86" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#dots)" data-id="element-87" />
        </svg>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-88">
        <div className="flex flex-col lg:flex-row items-center min-h-[calc(100vh-80px)] py-12 lg:py-0 gap-8 lg:gap-0" data-id="element-89">
          {/* Left — Text Content (55%) */}
          <div className="w-full lg:w-[55%] flex flex-col justify-center order-2 lg:order-1 pb-8 lg:pb-0 lg:pr-8" data-id="element-90">
            {/* Eyebrow */}
            <p className="uppercase font-semibold mb-5 tracking-widest" style={{
            color: '#0283C7',
            fontSize: '13px',
            letterSpacing: '0.18em',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-91">
              Residential &amp; Commercial Power Washing
            </p>

            {/* Animated Headline */}
            <h1 className="mb-6" style={{
            lineHeight: 1.08
          }} data-id="element-92">
              {lines.map((line, li) => <div key={li} className="block" data-id="element-93">
                  {line.text.split(' ').map((word, wi) => {
                const delay = li * 0.25 + wi * 0.1;
                return <span key={wi} className={`word-animate${wordsVisible ? '' : ''}`} style={{
                  fontFamily: 'Montserrat, sans-serif',
                  fontSize: 'clamp(32px, 5.5vw, 60px)',
                  fontWeight: 900,
                  color: line.color,
                  marginRight: '0.25em',
                  animationDelay: wordsVisible ? `${delay}s` : '9999s',
                  opacity: wordsVisible ? undefined : 0,
                  animation: wordsVisible ? `wordIn 0.5s ease-out ${delay}s forwards` : 'none'
                }} data-id="element-94">
                        {word}
                      </span>;
              })}
                </div>)}
            </h1>

            {/* Subheadline */}
            <p className="mb-8 max-w-xl transition-all duration-700" style={{
            color: '#025A8A',
            fontFamily: 'Inter, sans-serif',
            fontSize: 'clamp(15px, 1.8vw, 18px)',
            lineHeight: 1.7,
            opacity: subVisible ? 1 : 0,
            transform: subVisible ? 'translateY(0)' : 'translateY(16px)'
          }} data-id="element-95">
              Phoenix Valley's most trusted exterior cleaning team — 300+ jobs
              completed, 150+ five-star reviews, and one mission: make your
              property shine.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 mb-8 transition-all duration-700" style={{
            opacity: ctasVisible ? 1 : 0,
            transform: ctasVisible ? 'translateY(0)' : 'translateY(16px)'
          }} data-id="element-96">
              <a href="#contact" className="font-bold text-white text-center py-4 px-8 rounded-lg flex items-center justify-center min-h-[52px] transition-all duration-200 hover:scale-[1.03]" style={{
              backgroundColor: '#0283C7',
              fontFamily: 'Inter, sans-serif',
              fontSize: '16px',
              borderRadius: '8px',
              boxShadow: '0 4px 16px rgba(2,131,199,0.35)'
            }} data-id="element-97">
                Get a Free Quote
              </a>
              <a href="#video" className="font-bold text-center py-4 px-8 rounded-lg border-2 flex items-center justify-center gap-2 min-h-[52px] transition-all duration-200 hover:scale-[1.03]" style={{
              borderColor: '#0283C7',
              color: '#0283C7',
              fontFamily: 'Inter, sans-serif',
              fontSize: '16px',
              borderRadius: '8px',
              backgroundColor: '#ffffff'
            }} data-id="element-98">
                <PlayCircleIcon className="h-5 w-5" data-id="element-99" />
                Watch Our Story
              </a>
            </div>

            {/* Trust Row */}
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-5 transition-all duration-700" style={{
            opacity: ctasVisible ? 1 : 0,
            transform: ctasVisible ? 'translateY(0)' : 'translateY(16px)'
          }} data-id="element-100">
              <div className="flex items-center gap-2" data-id="element-101">
                <ShieldCheckIcon className="h-5 w-5" style={{
                color: '#0283C7'
              }} data-id="element-102" />
                <span className="font-semibold text-sm" style={{
                color: '#025A8A',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-103">
                  Licensed • Bonded • Insured
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-104">
                <div className="flex -space-x-2" data-id="element-105">
                  {['JL', 'JT', 'KR', 'MC', 'AA'].map((initials, i) => <div key={i} className="w-9 h-9 rounded-full border-2 border-white flex items-center justify-center font-bold text-xs text-white" style={{
                  backgroundColor: ['#0283C7', '#025A8A', '#0283C7', '#025A8A', '#0283C7'][i],
                  fontFamily: 'Inter, sans-serif',
                  zIndex: 5 - i
                }} data-id="element-106">
                      {initials}
                    </div>)}
                </div>
                <div data-id="element-107">
                  <div className="flex gap-0.5 mb-0.5" data-id="element-108">
                    {[1, 2, 3, 4, 5].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-current" style={{
                    color: '#F59E0B'
                  }} data-id="element-109" />)}
                  </div>
                  <p className="text-xs font-medium" style={{
                  color: '#025A8A',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-110">
                    from <strong data-id="element-111">150+ reviews</strong> on Google
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Right — Andy Cutout (45%) */}
          <div className="w-full lg:w-[45%] hidden lg:flex items-end justify-center order-1 lg:order-2 self-stretch relative" data-id="element-112">
            <img src="https://cdn.magicpatterns.com/uploads/oFApEuhQV1sGhNn1NLwotu/Untitled_design_(4).png" alt="Andy — Blue Cactus Power Washing Owner" className="absolute bottom-0 right-0 h-full object-contain object-bottom" style={{
            maxHeight: '620px',
            filter: 'drop-shadow(-8px 0 32px rgba(2,131,199,0.15))'
          }} data-id="element-113" />
          </div>
        </div>
      </div>

      {/* Client Logo Marquee Strip */}
      <div className="w-full border-t" style={{
      backgroundColor: '#ffffff',
      borderColor: '#E8F4FD'
    }} data-id="element-114">
        <div className="max-w-7xl mx-auto px-4 py-5" data-id="element-115">
          <p className="text-center text-xs uppercase tracking-widest mb-4 font-semibold" style={{
          color: '#0283C7',
          fontFamily: 'Inter, sans-serif',
          letterSpacing: '0.15em',
          opacity: 0.7
        }} data-id="element-116">
            Trusted by Local Arizona Businesses
          </p>
        </div>
        <div className="overflow-hidden pb-5" data-id="element-117">
          <div className="marquee-track" data-id="element-118">
            {[...BRANDS, ...BRANDS].map((brand, i) => <span key={i} className="inline-block font-bold text-base px-8" style={{
            color: '#0283C7',
            fontFamily: 'Montserrat, sans-serif',
            fontSize: '15px',
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            opacity: 0.55,
            whiteSpace: 'nowrap'
          }} data-id="element-119">
                {brand}
                <span className="ml-8 opacity-30" data-id="element-120">•</span>
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}